export default __webpack_public_path__ + "static/media/planta-h-1.2343fabf.jpg";